module.exports = __webpack_public_path__ + "static/Artboard-2-7a6c28da1dbe05daf3a49ff2f3ad41a8.png";